




















import { SfImage } from '~/components/StorefrontUi';
import {
  computed,
  defineComponent, PropType, ref,
} from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';

export default defineComponent({
  name: 'AddToWishlistHeart',
  components: {
    SfImage,
  },
  props: {
    isInWishlist: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isShow: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    title: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup(props, { emit }) {
    const isWishlistHovered = ref(false);
    // Computed Properties
    const wishlistIconResolver = computed(() => (!props.isInWishlist ? (isWishlistHovered.value ? 'heart-primary-fill' : 'heart-primary-outline') : 'heart-primary-fill'));
    const ariaLabel = computed(() => (props.isInWishlist ? 'Remove from wishlist' : 'Add to wishlist'));

    // Methods
    const setWishlistHovered = (value: boolean) => {
      isWishlistHovered.value = value;
    };

    const toggleIsInWishlist = () => {
      emit('click:wishlist', !props.isInWishlist);
    };

    return {
      addBasePath,
      setWishlistHovered,
      toggleIsInWishlist,
      wishlistIconResolver,
      ariaLabel,
    };
  },
});
